module.exports = __webpack_public_path__ + "static/media/gryphon_musee_abovethetrees_3.14423276.jpg";